/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestRawDev from '@/utils/requestRawDev'
import requestDev from '@/utils/requestDev'
import { APIReportPHP, APICore } from '@/utils/servicesApi'
const qs = require('qs')

export function updateDeleteChatStatus(data) {
    return requestRaw({
        url: APICore() + '/member/account/deletechat-status',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function settingAutoSwitchSender(data) {
    return requestRaw({
        url: APICore() + '/member/account/autoswitch-sender',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function getContactsTotal() {
    return requestRawDev({
        url: APIReportPHP() + '/member/contacts_total',
        method: 'GET',
    })
}

export function updateBank(data) {
    return requestRaw({
        url: APICore() + '/member/account/update-bank',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function getTimezones() {
    return requestRaw({
        url: APICore() + '/member/account/timezones',
        method: 'GET',
    })
}

export function updatePassword(data) {
    return requestRaw({
        url: APICore() + '/member/account/update-password',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function updateTimezone(data) {
    return requestRaw({
        url: APICore() + '/member/account/update-timezone',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function updateProfile(data) {
    return requestRaw({
        url: APICore() + '/member/account/update-profile',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function monthlyAgentsStatistic(params) {
    return requestDev({
        url: APIReportPHP() + '/member/monthly_agents_statistic',
        method: 'POST',
        data: qs.stringify(params)
    })
}


export function summaryAgents(params) {
    return requestDev({
        url: APIReportPHP() + '/member/summary_agents',
        method: 'POST',
        data: qs.stringify(params)
    })
}


export function monthlyActiveLicenses(params) {
    return requestDev({
        url: APIReportPHP() + '/member/monthly_active_licenses',
        method: 'POST',
        data: qs.stringify(params)
    })
}


export function getActiveVoucherTotal() {
    return requestRawDev({
        url: APIReportPHP() + '/member/active_voucher_total',
        method: 'GET',
    })
}

export function getLicenseTotal() {
    return requestRawDev({
        url: APIReportPHP() + '/member/license_total',
        method: 'GET',
    })
}

export function getAgentTotal() {
    return requestRawDev({
        url: APIReportPHP() + '/member/agent_total',
        method: 'GET',
    })
}

export function getMessageTotal(params) {
    return requestRawDev({
        url: APIReportPHP() + '/member/message_total?provider=' + params.provider,
        method: 'GET',
    })
}

export function getMessageSuccess(params) {
    return requestRawDev({
        url: APIReportPHP() + '/member/message_success_total?provider=' + params.provider,
        method: 'GET',
    })
}
export function getMessagePending(params) {
    return requestRawDev({
        url: APIReportPHP() + '/member/message_pending_total?provider=' + params.provider,
        method: 'GET',
    })
}

export function getMessageError(params) {
    return requestRawDev({
        url: APIReportPHP() + '/member/message_error_total?provider=' + params.provider,
        method: 'GET',
    })
}


// WEBPACK FOOTER //
// ./src/api/member.js